exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert {\r\n  line-height: 1.2rem !important;\r\n}\r\n.alert-warning a.alert-link:visited,\r\n.alert-warning a.alert-link:active,\r\n.alert-warning a.alert-link:link {\r\n  color: #b99400 !important;\r\n}\r\n.checkbox {\r\n  display: block;\r\n}\r\n.checkboxOverride {\r\n  display:-webkit-box;\r\n  display:-ms-flexbox;\r\n  display:flex;\r\n  -webkit-box-pack: justify;\r\n      -ms-flex-pack: justify;\r\n          justify-content: space-between;\r\n}\r\n/* @media (max-width:350px) {\r\n  .checkbox {\r\n    display: block !important;\r\n  }\r\n} */\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/login/login.component.css
// module id = ../../../../../src/app/component/login/login.component.css
// module chunks = main